<template>
  <div class="min-h-screen bg-gray-50 flex flex-col">
    <app-navbar></app-navbar>
    <fade-transition :duration="200" mode="out-in">
      <router-view></router-view>
    </fade-transition>
    <app-footer></app-footer>
  </div>
</template>
<script>
  import AppFooter from './layout/AppFooter'
  import AppNavbar from './layout/AppNavbar'
  import { FadeTransition } from 'vue2-transitions'

  export default {
    components: {
      AppFooter,
      AppNavbar,
      FadeTransition
    },
  }

</script>
<style lang="scss">
  .page__container {
    width: 100%;
    min-height: 100vh;
    background-color: $secondary-dark;

    .section-image {
      height: 100%;
    }
  }
</style>
